// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { RpcError } from "./RpcError";

/**
 * Represents the result of an RPC call.
 * A promise of either a result value `T` or an RPC error `E`.
 */
export type RpcResult<T, E> = Promise<Result<T, RpcError<E>>>;
